const Params = {
    gaTrackingId: process.env.REACT_APP_GOOGLE_ANALYTICS_ID || "",
    textareaMaxCharCount: 280
}

export default Params;
